import cn from 'classnames'
import { observer } from 'mobx-react'
import React from 'react'
import { PlacesType, Tooltip } from 'react-tooltip'

import { AlertCard } from '@flowwai-frontend/design-system'
import { i18nTProp } from '@flowwai-frontend/shared/common-components'

import { OPEN_IN_G_MAPS_TOOL_TIP_ID } from '../../constants'
import { imageUrls } from '../../constants/imageConstants'

import * as Styles from './styles'

interface OpenInGMapsPopoverProps extends React.PropsWithChildren {
   t: i18nTProp
   place?: PlacesType
}

const OpenInGMapsPopover = (
   props: OpenInGMapsPopoverProps
): React.ReactElement => {
   const { children, t } = props

   const renderAlertCard = (): React.ReactElement => (
      <AlertCard
         variant={'PRIMARY'}
         title={t('googleMapsTooltip')}
         containerClassName={cn(Styles.alertCardContainerStyles)}
      />
   )

   const renderImage = (): React.ReactElement => (
      <div
         className={cn(Styles.imageContainerStyles)}
         style={{
            backgroundImage: `url(${imageUrls.openInGMapsPreview})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            objectFit: 'fill'
         }}
      />
   )

   const renderContent = (): React.ReactElement => (
      <div className={cn(Styles.popoverContainerStyles, 'bg-base-white')}>
         {renderAlertCard()}
         {renderImage()}
      </div>
   )

   return (
      <div data-tooltip-id={OPEN_IN_G_MAPS_TOOL_TIP_ID}>
         {children}
         <Tooltip
            id={OPEN_IN_G_MAPS_TOOL_TIP_ID}
            place={props.place ?? 'bottom-end'}
            className={cn(Styles.tootipContainerStyles)}
            opacity={1}
            variant={'light'}
            offset={12}
            noArrow
         >
            {renderContent()}
         </Tooltip>
      </div>
   )
}

export default observer(OpenInGMapsPopover)
